import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GraphApiModule } from '@content-platform/web-angular-administration-shared-data-access-graph-api';
import { DevelopmentModule } from '@content-platform/web-angular-shared-util-development';
import { ContentPlatformUserService } from './interceptors/content-platform-user.service';
import { MsalInterceptorService } from './interceptors/msal-interceptor.service';
import { InterceptorDebugFlags } from './debug-flags';
import * as i0 from "@angular/core";
export class InterceptorsModule {
    static { this.ɵfac = function InterceptorsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InterceptorsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: InterceptorsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            {
                provide: HTTP_INTERCEPTORS,
                useClass: MsalInterceptorService,
                multi: true
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: ContentPlatformUserService,
                multi: true
            }
        ], imports: [CommonModule, GraphApiModule, DevelopmentModule.withFlags(InterceptorDebugFlags)] }); }
}
//# sourceMappingURL=interceptors.module.js.map